'use client';
import { createTheme, type ThemeOptions } from '@mui/material/styles';
import siteConfig from '@/config/site';

/**
 * Theme derived from config/site brand colours. Edit brand values there,
 * not here, so the whole look-and-feel is configured in one place.
 */
const base: ThemeOptions = {
  palette: {
    mode: siteConfig.brand.mode,
    primary: { main: siteConfig.brand.primary },
    secondary: { main: siteConfig.brand.secondary },
    // Neutres teintés chauds (crème/amande) plutôt que gris froids : la surface
    // d’une pâtisserie, pas un écran blanc.
    background: { default: '#FBF5EA', paper: '#FFFCF5' },
    text: { primary: '#2E2114', secondary: '#6B5840' },
    divider: '#E7D9C0',
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: 'var(--font-inter), system-ui, -apple-system, sans-serif',
    h1: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.1 },
    h2: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 700, letterSpacing: '-0.01em', lineHeight: 1.15 },
    h3: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 700, lineHeight: 1.2 },
    h4: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 700 },
    h5: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 600 },
    h6: { fontFamily: 'var(--font-frances), Georgia, serif', fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
    body1: { lineHeight: 1.7 },
    body2: { lineHeight: 1.65 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 999 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 16 } },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0, color: 'inherit' },
    },
  },
};

export const theme = createTheme(base);
export default theme;
